import * as z from "zod";
import { userFacingError } from "../authorization";
import { recordConnectorUsage, usageRef } from "../connectorUsages";
import { zql } from "../generatedDrizzleSchema";
import { assertPrincipalCanUseSupplier } from "../rbac/crossResourceAvailability";
import { mutator } from "./mutator";

export const associatePersonalChatWithConnectedApp = mutator({
  schema: z.object({
    personalChatId: z.string(),
    connectedAppId: z.string(),
  }),
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, ctx, args: { personalChatId, app } }) => {
    const [pc] = await tx.run(
      zql.personalChats.where("id", personalChatId).where("userId", ctx.userId)
    );
    if (!pc) throw userFacingError("Personal chat not found");

    await assertPrincipalCanUseSupplier(
      tx,
      ctx.tenantId,
      "personal_chat_uses_connected_apps",
      ctx.userId,
      app.id
    );

    const ref = usageRef.personalChat(personalChatId);
    const [existing] = await tx.run(
      zql.connectedAppUsages
        .where("connectedAppId", app.id)
        .where("type", ref.type)
        .where("refId", ref.refId)
    );
    if (existing) return;

    await recordConnectorUsage(tx, app.id, ref, ctx.tenantId);
  },
});
